import { DialogMemberType, MemberUser } from '@youhelp-ru/core';
import { User, UserType } from '../../user';

export const mapUserTypeToMemberType = (userType: UserType): DialogMemberType | null => {
  switch (userType) {
    case UserType.Client:
      return DialogMemberType.Client;
    case UserType.Admin:
      return DialogMemberType.Admin;
    default:
      return null;
  }
};

/**
 * Convert current user to dialog member user
 */
export const mapUserToMemberUser = (user: User): MemberUser | null => {
  const type = mapUserTypeToMemberType(user.type);
  if (!type) {
    return null;
  }
  return new MemberUser(type, user.id);
};
